// La stazione di ricarica aperta da una VM LeaRes (WERESP_WEB apre
// `${PORTAL_URL}/account?recharge=1` in una scheda nuova, ticket 6a9e5f9c).
//
// L'intenzione si ricorda per la SCHEDA (sessionStorage), non per l'URL: fra
// l'arrivo e la chiusura la scheda puo' passare dal login o da un giro su
// Stripe, e il parametro si perde. Chiudere la stazione chiude la scheda e
// l'utente e' di nuovo sulla VM, con il lavoro aperto com'era. Se il browser
// non lascia chiudere la scheda (aperta a mano, non da script) resta la
// dashboard del portale.

const KEY = 'lexmed.rechargeFromVm'

export const captureRechargeIntent = (search = window.location.search) => {
  try {
    if (new URLSearchParams(search).has('recharge')) {
      sessionStorage.setItem(KEY, '1')
    }
  } catch {
    // storage bloccato: la stazione si apre comunque da ?recharge, ma non
    // sopravvive a un login intermedio
  }
}

export const hasRechargeIntent = () => {
  try {
    return sessionStorage.getItem(KEY) === '1'
  } catch {
    return false
  }
}

export const finishRechargeFromVm = () => {
  if (!hasRechargeIntent()) return
  try {
    sessionStorage.removeItem(KEY)
  } catch {
    // niente da pulire
  }
  window.close()
}
